export default {"src":"/_next/static/media/videocall_24.90dd6001.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};